module.exports = __webpack_public_path__ + "static/img/page-header.e904d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/page-header.jpg
// module id = BLCG
// module chunks = 9